// This file is auto-generated by 'pnpm rebuild:icons'
import type { TemplateOnlyComponent } from '@ember/component/template-only';

import type { Signature } from './types.ts';

const IconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='15.5'
    height='15.5'
    viewBox='0 0 15.5 15.5'
    ...attributes
  ><g
      fill='none'
      stroke='var(--icon-color, currentColor)'
      stroke-linecap='round'
      stroke-linejoin='round'
      stroke-width='1.5'
    ><path
        d='M7.75.75v2.8M7.75 11.95v2.8M2.801 2.801l1.981 1.981M10.718 10.718l1.981 1.981M.75 7.75h2.8M11.95 7.75h2.8M2.801 12.699l1.981-1.981M10.718 4.782l1.981-1.981'
      /></g></svg>
</template>;

// @ts-expect-error this is the only way to set a name on a Template Only Component currently
IconComponent.name = 'LoadingIndicator';
export default IconComponent;
